import { render, staticRenderFns } from "./BaseApplicableMultiSelect.vue?vue&type=template&id=96881cf8&scoped=true"
import script from "./BaseApplicableMultiSelect.vue?vue&type=script&lang=js"
export * from "./BaseApplicableMultiSelect.vue?vue&type=script&lang=js"
import style0 from "./BaseApplicableMultiSelect.vue?vue&type=style&index=0&id=96881cf8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "96881cf8",
  null
  
)

export default component.exports